// src/translations/translations.js
import { translationWorks } from "./TranslationWorks";
import { translationBlog } from "./TranslationBlog";

export const translations = {
  en: {
    // Navigation
    home: "Home",
    works: "Works",
    about: "About",
    code: "Developer",
    blog: "Articles",
    playground: "Playground",

    // Home hero (light hub)
    getInTouch: "Get in touch",
    heroTag: "Broadcast · Development · Teaching",
    heroTagBroadcast: "Broadcast",
    heroTagDev: "Development",
    heroTagTeaching: "Teaching",
    heroClaim: "Senior Creative Technologist.",
    heroBio:
      "Fifteen years of broadcast graphics for Italian national television, a parallel path as a full-stack developer, and teaching virtual production as an Unreal Authorized Instructor.",
    watchReel: "Watch reel",

    heroStat1Value: "15+",
    heroStat1Label: "Years in broadcast",
    heroStat2Value: "RAI · LA7 · D&G",
    heroStat2Label: "National television",
    heroStat3Value: "React · Three.js · Python",
    heroStat3Label: "Full-stack development",
    heroStat4Value: "Unreal Engine",
    heroStat4Label: "Authorized Instructor",

    // Pathways section
    pathwaysTitle: "Explore by area",
    pathwayBroadcastTitle: "Broadcast & Virtual Production",
    pathwayBroadcastBody:
      "Fifteen years on national television — RAI, LA7, Dolce & Gabbana. Virtual studios, AR, live delivery.",
    pathwayDevTitle: "Development",
    pathwayDevBody:
      "React, Python, Supabase. Full-stack products shipped and used in production.",
    pathwayTrainerTitle: "Teaching",
    pathwayTrainerBody:
      "Unreal Authorized Instructor. Virtual production and advanced 3D at ITS Apulia Digital Maker.",
    pathwayCta: "Explore",

    // Featured projects (home)
    featuredProjectsTitle: "Selected Work",
    featuredProjectsViewAll: "View all projects",
    featuredCategoryBroadcast: "Broadcast / Motion Graphics",
    featuredCategoryVP: "Virtual Production",
    featuredCategoryDev: "React Web App",

    // About section
    aboutIntro:
      "Fifteen years of broadcast graphics for Italian national television, and a parallel path as a full-stack developer — plus teaching virtual production and Unreal Engine.",
    readMore: "READ MORE",

    // Skills section
    skillsTitle: "Skills",
    skillsSubtitle:
      "A cross-disciplinary stack, built across broadcast, development and teaching",
    skillsGroupBroadcast: "Broadcast & Virtual Production",
    skillsGroupDev: "Development",
    skillsGroupTeaching: "Teaching & Tools",
    skillsBroadcastItems: [
      "Unreal Engine",
      "Pixotope",
      "Blender",
      "Cinema 4D",
      "Camera Tracking",
      "Avid Maestro",
    ],
    skillsDevItems: [
      "React",
      "Three.js / R3F",
      "Python",
      "Supabase",
      "Tailwind CSS",
    ],
    skillsTeachingItems: [
      "Unreal Authorized Instructor",
      "After Effects",
      "Blender API / Addons",
      "Git",
    ],

    // CodeShowcase section
    developmentTag: "Development",
    featuredCode: "Featured Code",
    featuredCodeDesc:
      "Full-stack applications built with a broadcast background and a focus on reliability.",
    viewAllProjects: "View all projects",
    portfolioDev: "portfolio@dev:~/projects",
    useArrowKeys: "Use arrow keys to navigate • Enter to open",
    lsCommand: "ls -la ./featured-projects/",
    totalProjects: "total",
    clickProject: "Click on a project or use keyboard navigation",
    selected: "selected",
    github: "Github",
    live: "Live",
    details: "Details",
    openCommand: "open",
    projectPlaceholder: "project-name...",
    projectNotFound: "Project not found. Try:",
    typeProjectName: "Type a project name and press Enter to open it directly",

    // Contact section
    contactIntro:
      "Fifteen years in live broadcast production, plus full-stack development and a few tools I built along the way. Happy to talk about any of it.",
    aboutMe: "ABOUT ME",
    goToWorks: "GO TO WORKS PAGE",
    goToDeveloper: "GO TO DEVELOPER PAGE",
    playgroundLink: "PLAYGROUND",

    // CCTV Stream
    rec: "REC",
    cam_info: "CAM-01 / FRONT DESK",
    resolution: "RESOLUTION: 1920x1080",
    fps: "FPS: 30",
    system_active: "SYSTEM: ACTIVE",
    motion_detect: "MOTION DETECT: ON",
    initializing_camera: "INITIALIZING CAMERA...",
    system_error: "SYSTEM ERROR",
    camera_access_denied: "CAMERA ACCESS DENIED",
    retry_connection: "RETRY CONNECTION",

    // About page
    aboutIntroPage:
      "Fifteen years in Italian national broadcast, working in control rooms and on live programmes with early starts and tight deadlines.\n\nI started writing code to solve production problems, automating workflows and building small tools where off-the-shelf software fell short. That grew into full-stack development, which is what I'm focused on now, alongside teaching and my broadcast work.",
    contactIntroPage:
      "Happy to discuss broadcast, virtual production, web development, or any project you're working on.\n\nGet in touch.",
    availableForWork: "AVAILABLE FOR WORK",
    mySkills: "My Skills",
    skillsDesc:
      "Tools I've used across broadcast production and web development.",
    loading3D: "Loading 3D Skills Scene",
    preparingExp: "Preparing interactive experience...",
    backHome: "BACK HOME",
    downloadResume: "DOWNLOAD FULL RESUME",

    // Timeline About
    timelineAbout: "My Journey",
    timelineInfo:
      "A chronological record of work done in live television and broadcast production, from 2009 to the present.",

    // Timeline Items
    timeline_item1_title: "Broadcast Career Begins",
    timeline_item1_desc:
      "Joined a production company working in Italian national broadcast. Started building real-time 3D graphics for television.",
    timeline_item2_title: "First Virtual Studio, LA7",
    timeline_item2_desc:
      "Designed and delivered the virtual studio for 'Atlantide' on LA7. My first full-scale broadcast virtual production.",
    timeline_item3_title: "Augmented Reality & Rainews24",
    timeline_item3_desc:
      "Built real-time AR graphics for the French presidential elections on LA7. Designed and deployed a new graphics system for Rainews24, still on air today.",
    timeline_item4_title: "L'aria che tira, LA7",
    timeline_item4_desc:
      "Five years as AR graphic designer for 'L'aria che tira' on LA7, working daily with director Ermanno Corbella.",
    timeline_item5_title: "ITS Instructor",
    timeline_item5_desc:
      "Taught virtual production and advanced 3D at ITS Apulia Digital Maker. Two students later hired at my company. One is still there.",
    timeline_item6_title: "Viva Rai 2!",
    timeline_item6_desc:
      "Daily real-time graphics for Fiorello's national morning show on Rai 2. 5:30am starts, live direction changes, eight hours of broadcast every day.",
    timeline_item7_title: "Building for the Web",
    timeline_item7_desc:
      "Moved into full-stack development. Built LifeOS, Spese Comuni, and a couple of Blender addons released as open source. Open to roles at the intersection of technology, media, and production.",

    // Works page
    works_title: "My Works",
    works_desc:
      "Broadcast, virtual production, fashion. Fifteen years of work for Italian national television and beyond.",
    view_project: "View project",

    // Code page
    code_badge: "Code & Engineering",
    code_title: "My Code",
    code_desc:
      "Full-stack applications, automation tools, and experiments in AI and generative media.",
    selected_work: "Selected Work",
    project_singular: "Project",
    projects_plural: "Projects",
    goToPlayground: "GO TO PLAYGROUND",

    // Work Detail page
    project_not_found: "Project not found",
    return_to_works: "Return to Works",
    return_to_code: "Return to Code Projects",
    loading_project: "Loading Project",
    preparing: "Preparing...",
    next_project: "Next Project",
    view_all_works: "View all works",
    view_project: "View project",
    code_nav: "Code",
    cd_view_code: "View Code",
    cd_live_demo: "Live Demo",
    cd_category: "Category",
    cd_key_features: "Key Features",
    cd_production_metrics: "Production Metrics",
    cd_overview: "Overview",
    cd_tech_stack: "Tech Stack",
    cd_code_snippets: "Code Snippets",
    cd_challenges: "Challenges & Solutions",
    cd_video_demo: "Video Demonstration",
    cd_live_preview: "Live Preview",
    cd_iframe_hint: "Interactive demo embedded — or",
    cd_open_fullscreen: "open fullscreen",
    cd_screenshots: "Screenshots",
    wd_client: "Client",
    wd_services: "Services",
    wd_technologies: "Technologies",
    wd_color_palette: "Color Palette",
    wd_overview: "Overview",
    wd_project_gallery: "Project Gallery",
    wd_project_video: "Project Video",
    wd_client_feedback: "Client Feedback",
    wd_loading_image: "Loading image...",
    wd_loading_gallery: "Loading gallery...",
    wd_loading_video: "Loading video...",

    // Blog
    blog_subtitle:
      "Broadcast design, code, 3D workflow, and the things going through my mind.",

    // Custom Cursor
    cursor_scroll_explore: "scroll to explore",
    cursor_click_see_more: "Click to see more",
    cursor_view_work: "view work",
    cursor_execute_script: "execute script",
    cursor_view_project: "view project",
    cursor_go_to_playground: "go to playground",
    cursor_click_navigate: "click to navigate",
    cursor_play_video: "play video",
    cursor_collaboration: "collaboration",
    cursor_everyday_tools: "everyday tools",
    cursor_get_in_touch: "get in touch",
    cursor_activate_camera: "activate camera",
    cursor_go_back_home: "go back home",
    cursor_scroll_top: "scroll to top",
    cursor_explore_works: "explore works",
    cursor_turn_off_lights: "turn off lights",
    cursor_turn_on_lights: "turn on lights",
    cursor_show_reel: "show reel 2025",
    cursor_show_project: "show project",
    cursor_type_project: "type project",
  },

  it: {
    // Navigation
    home: "Home",
    works: "Lavori",
    about: "Chi sono",
    code: "Developer",
    blog: "Blog",
    playground: "Playground",

    // Home hero (light hub)
    getInTouch: "Contattami",
    heroTag: "Broadcast · Sviluppo · Docenza",
    heroTagBroadcast: "Broadcast",
    heroTagDev: "Sviluppo",
    heroTagTeaching: "Docenza",
    heroClaim: "Senior Creative Technologist.",
    heroBio:
      "Quindici anni di grafica broadcast per la televisione nazionale italiana, un percorso parallelo da sviluppatore full-stack, e docenza in virtual production come Unreal Authorized Instructor.",
    watchReel: "Guarda il reel",

    heroStat1Value: "15+",
    heroStat1Label: "Anni nel broadcast",
    heroStat2Value: "RAI · LA7 · D&G",
    heroStat2Label: "Televisione nazionale",
    heroStat3Value: "React · Three.js · Python",
    heroStat3Label: "Sviluppo full-stack",
    heroStat4Value: "Unreal Engine",
    heroStat4Label: "Instructor autorizzato",

    // Pathways section
    pathwaysTitle: "Esplora per ambito",
    pathwayBroadcastTitle: "Broadcast & Virtual Production",
    pathwayBroadcastBody:
      "Quindici anni sulla televisione nazionale — RAI, LA7, Dolce & Gabbana. Studi virtuali, AR, consegna live.",
    pathwayDevTitle: "Sviluppo",
    pathwayDevBody:
      "React, Python, Supabase. Prodotti full-stack shippati e usati in produzione.",
    pathwayTrainerTitle: "Docenza",
    pathwayTrainerBody:
      "Unreal Authorized Instructor. Virtual production e 3D avanzato all'ITS Apulia Digital Maker.",
    pathwayCta: "Esplora",

    // Featured projects (home)
    featuredProjectsTitle: "Lavori Selezionati",
    featuredProjectsViewAll: "Vedi tutti i progetti",
    featuredCategoryBroadcast: "Broadcast / Motion Graphics",
    featuredCategoryVP: "Virtual Production",
    featuredCategoryDev: "React Web App",

    // About section
    aboutIntro:
      "Quindici anni di grafica broadcast per la televisione nazionale italiana, e un percorso parallelo da sviluppatore full-stack — oltre alla docenza in virtual production e Unreal Engine.",
    readMore: "LEGGI DI PIÙ",

    // Skills section
    skillsTitle: "Competenze",
    skillsSubtitle:
      "Uno stack trasversale, costruito tra broadcast, sviluppo e docenza",
    skillsGroupBroadcast: "Virtual Production",
    skillsGroupDev: "Sviluppo",
    skillsGroupTeaching: "Docenza & Strumenti",
    skillsBroadcastItems: [
      "Unreal Engine",
      "Pixotope",
      "Blender",
      "Cinema 4D",
      "Camera Tracking",
      "Avid Maestro",
    ],
    skillsDevItems: [
      "React",
      "Three.js / R3F",
      "Python",
      "Supabase",
      "Tailwind CSS",
    ],
    skillsTeachingItems: [
      "Unreal Authorized Instructor",
      "After Effects",
      "Blender API / Addons",
      "Git",
    ],

    // CodeShowcase section
    developmentTag: "Sviluppo",
    featuredCode: "Codice in Evidenza",
    featuredCodeDesc:
      "Applicazioni full-stack sviluppate con un background broadcast e attenzione all'affidabilità.",
    viewAllProjects: "Vedi tutti i progetti",
    portfolioDev: "portfolio@dev:~/progetti",
    useArrowKeys: "Usa le frecce per navigare • Invio per aprire",
    lsCommand: "ls -la ./progetti-in-evidenza/",
    totalProjects: "totale",
    clickProject: "Clicca su un progetto o usa la navigazione da tastiera",
    selected: "selezionato",
    github: "Github",
    live: "Live",
    details: "Dettagli",
    openCommand: "apri",
    projectPlaceholder: "nome-progetto...",
    projectNotFound: "Progetto non trovato. Prova:",
    typeProjectName:
      "Digita il nome di un progetto e premi Invio per aprirlo direttamente",

    // Contact section
    contactIntro:
      "Quindici anni di produzione broadcast in diretta, più sviluppo full-stack e qualche strumento costruito lungo il percorso. Scrivimi se vuoi parlarne.",
    aboutMe: "CHI SONO",
    goToWorks: "VAI ALLA PAGINA LAVORI",
    goToDeveloper: "VAI ALLA PAGINA DEVELOPER",
    playgroundLink: "PLAYGROUND",

    // CCTV Stream
    rec: "REC",
    cam_info: "CAM-01 / SCRIVANIA FRONTALE",
    resolution: "RISOLUZIONE: 1920x1080",
    fps: "FPS: 30",
    system_active: "SISTEMA: ATTIVO",
    motion_detect: "RILEVAMENTO MOVIMENTO: ATTIVO",
    initializing_camera: "INIZIALIZZAZIONE CAMERA...",
    system_error: "ERRORE DI SISTEMA",
    camera_access_denied: "ACCESSO CAMERA NEGATO",
    retry_connection: "RIPROVA CONNESSIONE",

    // About page
    aboutIntroPage:
      "Quindici anni nella televisione nazionale italiana. Control room, render farm, sveglie alle 5 su programmi in diretta.\n\nHo iniziato a scrivere codice per risolvere problemi di produzione: automatizzare workflow, costruire piccoli strumenti dove il software preconfezionato non bastava. Da lì è cresciuto lo sviluppo full-stack, che oggi è il mio focus principale, insieme alla docenza e al lavoro nel broadcast.",
    contactIntroPage:
      "Disponibile a parlare di broadcast, produzione virtuale, sviluppo web o di qualsiasi progetto tu stia seguendo.\n\nScrivimi.",
    availableForWork: "DISPONIBILE PER LAVORO",
    mySkills: "Le Mie Competenze",
    skillsDesc:
      "Strumenti che ho usato tra produzione broadcast e sviluppo web.",
    loading3D: "Caricamento Scena 3D Competenze",
    preparingExp: "Preparazione dell'esperienza interattiva...",
    backHome: "HOME",
    downloadResume: "SCARICA IL CURRICULUM COMPLETO",

    // Timeline About
    timelineAbout: "La Mia Storia",
    timelineInfo:
      "Una cronologia del lavoro svolto in televisione live e produzione broadcast, dal 2009 a oggi.",

    // Timeline Items
    timeline_item1_title: "Inizio nel Broadcast",
    timeline_item1_desc:
      "Entrato in una società di produzione che lavorava per la televisione nazionale italiana. Ho iniziato a costruire grafica 3D in tempo reale per la televisione.",
    timeline_item2_title: "Primo Studio Virtuale, LA7",
    timeline_item2_desc:
      "Progettato e realizzato lo studio virtuale per 'Atlantide' su LA7. La mia prima produzione virtuale broadcast in scala reale.",
    timeline_item3_title: "Realtà Aumentata & Rainews24",
    timeline_item3_desc:
      "Grafica AR in tempo reale per le elezioni presidenziali francesi su LA7. Sistema grafico per Rainews24 progettato e installato da zero, ancora in onda.",
    timeline_item4_title: "L'aria che tira, LA7",
    timeline_item4_desc:
      "Cinque anni come grafico AR per 'L'aria che tira' su LA7, lavorando ogni giorno con il regista Ermanno Corbella.",
    timeline_item5_title: "Docente ITS",
    timeline_item5_desc:
      "Insegnato produzione virtuale e 3D avanzato all'ITS Apulia Digital Maker. Due studenti poi assunti nella mia stessa azienda. Una è ancora lì.",
    timeline_item6_title: "Viva Rai 2!",
    timeline_item6_desc:
      "Grafica in tempo reale ogni giorno per il morning show nazionale di Fiorello su Rai 2. Sveglia alle 5:30, variazioni live, otto ore di broadcast al giorno.",
    timeline_item7_title: "Costruire per il Web",
    timeline_item7_desc:
      "Passato allo sviluppo full-stack. Costruito LifeOS, Spese Comuni e un paio di addon per Blender rilasciati come open source. Aperto a ruoli all'intersezione tra tecnologia, media e produzione.",

    // Works page
    works_title: "I Miei Lavori",
    works_desc:
      "Broadcast, produzione virtuale, moda. Quindici anni di lavoro per la televisione nazionale italiana e non solo.",
    view_project: "Visualizza progetto",

    // Code page
    code_badge: "Codice & Ingegneria",
    code_title: "Il Codice",
    code_desc:
      "Applicazioni full-stack, strumenti di automazione ed esperimenti in ambito AI e media generativi.",
    selected_work: "Lavori Selezionati",
    project_singular: "Progetto",
    projects_plural: "Progetti",
    goToPlayground: "VAI AL PLAYGROUND",

    // Work Detail page
    project_not_found: "Progetto non trovato",
    return_to_works: "Torna ai Lavori",
    return_to_code: "Torna ai Progetti Code",
    loading_project: "Caricamento Progetto",
    preparing: "Preparazione...",
    next_project: "Progetto Successivo",
    view_all_works: "Vedi tutti i lavori",
    view_project: "Visualizza progetto",
    code_nav: "Code",
    cd_view_code: "Vedi Codice",
    cd_live_demo: "Demo Live",
    cd_category: "Categoria",
    cd_key_features: "Funzionalità Principali",
    cd_production_metrics: "Metriche di Produzione",
    cd_overview: "Panoramica",
    cd_tech_stack: "Stack Tecnologico",
    cd_code_snippets: "Frammenti di Codice",
    cd_challenges: "Sfide & Soluzioni",
    cd_video_demo: "Dimostrazione Video",
    cd_live_preview: "Anteprima Live",
    cd_iframe_hint: "Demo interattiva incorporata — oppure",
    cd_open_fullscreen: "apri a schermo intero",
    cd_screenshots: "Screenshot",
    wd_client: "Cliente",
    wd_services: "Servizi",
    wd_technologies: "Tecnologie",
    wd_color_palette: "Palette Colori",
    wd_overview: "Panoramica",
    wd_project_gallery: "Galleria Progetto",
    wd_project_video: "Video Progetto",
    wd_client_feedback: "Feedback Cliente",
    wd_loading_image: "Caricamento immagine...",
    wd_loading_gallery: "Caricamento galleria...",
    wd_loading_video: "Caricamento video...",

    // Blog

    blog_subtitle:
      "Broadcast design, codice, 3D workflow, e tutto quello che mi passa per la testa (scrivo solo in inglese).",

    // Custom Cursor
    cursor_scroll_explore: "scrolla e esplora",
    cursor_click_see_more: "Clicca per saperne di più",
    cursor_view_work: "vedi lavoro",
    cursor_execute_script: "esegui script",
    cursor_view_project: "vedi progetto",
    cursor_go_to_playground: "vai al playground",
    cursor_click_navigate: "clicca per navigare",
    cursor_play_video: "riproduci video",
    cursor_collaboration: "collaborazione",
    cursor_everyday_tools: "strumenti quotidiani",
    cursor_get_in_touch: "mettiti in contatto",
    cursor_activate_camera: "attiva la camera",
    cursor_go_back_home: "torna alla home",
    cursor_scroll_top: "torna su",
    cursor_explore_works: "esplora i lavori",
    cursor_turn_off_lights: "spegni le luci",
    cursor_turn_on_lights: "accendi le luci",
    cursor_show_reel: "show reel 2025",
    cursor_show_project: "mostra progetto",
    cursor_type_project: "digita progetto",
  },
};

export const useTranslation = (language) => {
  const merged = {
    ...translations[language],
    ...translationWorks[language],
    ...translationBlog[language],
  };
  return (key) => merged[key] || key;
};
